"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    color: "inherit"
  },
  figure: {
    width: props => {
      return props.size;
    },
    height: props => {
      return props.size;
    },
    margin: "12px",
    "& svg, & img": {
      boxSizing: "inherit",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      width: "100%",
      height: "100%",
      margin: "auto"
    }
  },
  img: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    maxWidth: "64px",
    maxHeight: "64px",
    margin: "auto"
  },
  label: {
    display: "block",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "12px",
    marginTop: "-1em"
  }
}));

const AppsGridItem = ({
  title,
  imageUrl,
  icon,
  size = "large",
  onClick
}) => {
  const sizes = {
    "small": 36,
    "medium": 48,
    "large": 64
  };
  size = sizes[size] || size || 64;
  const classes = useStyles({
    size
  });
  return _react.default.createElement(_ButtonBase.default, {
    className: classes.root,
    disableRipple: true,
    onClick: onClick
  }, _react.default.createElement(_IconButton.default, {
    className: classes.figure,
    component: "figure"
  }, !icon && imageUrl && _react.default.createElement("img", {
    className: classes.img,
    src: imageUrl
  }), icon), _react.default.createElement(_Typography.default, {
    className: classes.label,
    noWrap: true
  }, title));
};

var _default = AppsGridItem;
exports.default = _default;
module.exports = exports.default;